const BOT_PATTERN = /googlebot|google-inspectiontool|googleother|storebot-google|bingbot|adsbot-google|mediapartners-google|google page speed insights|reactsnap|yandexbot|applebot|duckduckbot|baiduspider|facebookexternalhit|twitterbot|linkedinbot|slurp|petalbot|ahrefsbot|semrushbot|gptbot|claudebot|bytespider|amazonbot|chrome-lighthouse/i;

const STATIC_CONTENT_PATH = /^\/(cost-guides|costs|tradespeople|blog|about|faqs|contact|support|policies|careers|sustainability|for-tradespeople|warm-homes-plan|free-resources|learn-more|partners|cost-calculator|quote-check|your-home|apps|reviews|home|contractor-packages|reports|local-contractors|newsletter|trades-newsletter|day-rates|trusted-by-percy|trust-score|homeowner-trust|verify|trade-advice|estimators|widget-installation)(\/|$)/;

export const isBotUserAgent = (userAgent) => {
  if (typeof userAgent !== "string") return true;
  return BOT_PATTERN.test(userAgent);
};

export const isStaticContentPath = (pathname) =>
  pathname === "/" || STATIC_CONTENT_PATH.test(pathname);
